module.exports = __webpack_public_path__ + "img/ego-university.d82671f.jpg";